<div slot="content" class="p-3 flex-fill w-100 mx-auto">
  <dx-toolbar class="mb-4">
    <dxi-item location="after" class="d-flex gap-3 align-items-center">
      <i class="dx-icon dx-icon-search"></i>
      <dx-autocomplete
        class="w-100"
        [minSearchLength]="0"
        [dataSource]="searchNames"
        [showClearButton]="true"
        [showDropDownButton]="true"
        valueChangeEvent="blur"
        placeholder="{{ 'Suche Katalog' | translate }}"
        [(value)]="searchText"
        (onInput)="updateSearchText()"
        [readOnly]="!canEdit('responsible')"
      ></dx-autocomplete>
    </dxi-item>
    <dxi-item *ngIf="!isDataProcessContainer" location="before">
      <dx-button
        [visible]="canView('newCatalogButton')"
        stylingMode="text"
        type="default"
        text="{{ 'Neuer Katalog' | translate }}"
        (onClick)="showAddCatalog()"
        hint="{{ 'Neuen, leeren Katalog anlegen' | translate }}"
      ></dx-button>
    </dxi-item>
    <dxi-item *ngIf="!isDataProcessContainer" location="before">
      <dx-button
        stylingMode="text"
        type="default"
        *ngIf="copyCatalogId != ''"
        text="Katalog einfügen"
        (onClick)="pasteCatalog()"
        hint="{{ 'Katalog einfügen' | translate }}"
      ></dx-button>
    </dxi-item>
    <dxi-item location="before">
      <dx-button
        [visible]="canView('refreshButton')"
        stylingMode="text"
        type="default"
        text="{{ 'Aktualisieren' | translate }}"
        (onClick)="refresh()"
        hint="{{ 'Katalogliste aktualisieren' | translate }}"
      ></dx-button>
    </dxi-item>
    <dxi-item location="before">
      <dx-button
        [visible]="canView('importButton')"
        stylingMode="text"
        type="default"
        text="{{ 'Importieren' | translate }}"
        (onClick)="showImportCatalog()"
        hint="{{ 'Katalog hochladen (Excel, BMEcat)' | translate }}"
      ></dx-button>
    </dxi-item>
  </dx-toolbar>
  <div class="d-inline-flex gap-4">
    <np-catalog-card
      *ngFor="let catalog of foundCatalogs"
      [model]="catalog"
      [showDuplicateButton]="false"
      [showCopyButton]="false"
      [showRestoreButton]="false"
      [showEditButton]="true"
    ></np-catalog-card>
  </div>

  <dx-load-panel
    #loadPanelChecKVirtualCatalogs
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ offset: { x: 0, y: 50 } }"
    [(visible)]="loading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="false"
    [hideOnOutsideClick]="false"
  ></dx-load-panel>

  <dx-popover
    [(target)]="memoTarget"
    position="bottom"
    [width]="300"
    [showTitle]="true"
    title="Notiz"
    [(visible)]="memoVisable"
  >
    <div *dxTemplate="let data = model; of: 'content'">
      <span [innerHTML]="memoText"></span>
    </div>
  </dx-popover>
</div>

<dx-popup
  class="popup"
  [width]="600"
  [height]="400"
  [showTitle]="true"
  title="{{ 'Neuer Katalog' | translate }}"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="addCatalogVisible"
  contentTemplate="popupContent"
>
  <div *dxTemplate="let data of 'popupContent'">
    <newCatalog [stage]="stage" [containerId]="containerId"></newCatalog>
  </div>
</dx-popup>

<dx-popup
  class="popup"
  [width]="800"
  minHeight="550"
  [height]="'auto'"
  [showTitle]="true"
  title="{{ 'Katalog importieren' | translate }}"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="importCatalogVisible"
  contentTemplate="popupContent"
>
  <div *dxTemplate="let data of 'popupContent'">
    <importCatalog [stage]="stage" [containerId]="containerId"></importCatalog>
  </div>
</dx-popup>

<dx-popup
  title="{{ 'Datensicherungen' | translate }}"
  [width]="1000"
  [height]="800"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="backUpVisible"
  (onHiding)="hideBackUp()"
  contentTemplate="popupContent"
>
  <dxi-popup-toolbar-item toolbar="top" location="after" widget="dxDropDownButton">
    <np-help-button>
      <np-help-option
        text="YouTube"
        icon="images/YouTube.svg"
        link="https://www.youtube.com/watch?v=cElY9pFqz2I"
      ></np-help-option>
    </np-help-button>
  </dxi-popup-toolbar-item>
  <div *dxTemplate="let data of 'popupContent'">
    <backup></backup>
  </div>
</dx-popup>

<jobdata [(visible)]="jobDataVisible"></jobdata>

<dx-popover [(target)]="target" position="bottom" [width]="300" [showTitle]="false" [(visible)]="imageVisable">
  <div *dxTemplate="let data = model; of: 'content'">
    <img src="{{ source }}{{ mimedate() }}" style="height: 244px" />
  </div>
</dx-popover>

<dx-popup
  class="popup"
  [width]="600"
  [height]="400"
  [showTitle]="true"
  title="{{ 'Willkommen' | translate }}"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [(visible)]="welcomePopupVisible"
  contentTemplate="popupContent"
>
  <dxi-popup-toolbar-item toolbar="top" location="after" widget="dxDropDownButton">
    <np-help-button>
      <np-help-option
        text="Wiki"
        icon="images/Wiki.svg"
        link="https://knowledge.nextpim.de/?utm_source=app.nextpim.de&utm_medium=affiliate&utm_campaign=wikilink"
      ></np-help-option>
      <np-help-option
        text="YouTube"
        icon="images/YouTube.svg"
        link="https://www.youtube.com/watch?v=gHtxkwiks9k"
      ></np-help-option>
    </np-help-button>
  </dxi-popup-toolbar-item>
  <div *dxTemplate="let data of 'popupContent'">
    <div *ngIf="!isGastro()" [innerHTML]="'Welcome-Message' | translate"></div>
    <div *ngIf="isGastro()" [innerHTML]="'Welcome-MessageGastro' | translate"></div>
  </div>
</dx-popup>
